export default {
  apiHost:'https://myapi.davinci-pay.com',
  // apiHost:'http://127.0.0.1:9088',
};
